import { IAuthRepository } from "@/core/repositories/auth";
import { createLogger, ILogger } from "@/infrastructure/services/logger";
import { UserContext } from "@/infrastructure/context";
export class LogoutUseCase {
  private readonly logger: ILogger = createLogger("LogoutUseCase");

  constructor(private readonly authRepository: IAuthRepository) {
  }

  async execute(): Promise<void> {
    this.logger.info("User logout", {
      email: UserContext.getInstance().getUser()?.email,
      name: UserContext.getInstance().getUser()?.fullName,
    });
    return this.authRepository.logout();
  }
}
